import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AlertModel } from '../../viewmodels/alert.model';
import * as moment from 'moment';
import { Constants } from '../../../shared/common/helper/constants';
import { AdminService } from '../../services/admin.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'alerts-list',
  templateUrl: './alerts-list.component.html',
  styleUrls: ['./alerts-list.component.scss'],
})
export class AlertsListComponent implements OnInit {
  @ViewChild('alertsFilterForm') alertsFilterForm: NgForm;

  constants = Constants;
  alerts: Array<AlertModel> = [];
  originalAlerts: Array<AlertModel> = [];
  alertsFilter = '';
  filterOrder = {
    isIdAsc: true,
    isTypeAsc: true,
    isDateAsc: true,
    isNameAsc: true,
    isInstructionsAsc: true,
    isDisplayedAsc: true,
    isAppliedAsc: true,
  };
  displayDateFormat = 'DD/MM/YYYY';
  sortDateFormat = 'YYYY-MM-DD';
  filterShowList = [
    {
      id: 99,
      name: 'all items',
    },
    {
      id: 0,
      name: 'alerts',
    },
    {
      id: 2,
      name: 'custom paragraphs',
    },
    {
      id: 1,
      name: 'custom letters',
    },
  ];
  filter = {
    show: 99,
    createdBy: '0',
    whichAre: 0,
  };
  searchCriteria = '';
  usersList = [];

  alertsUniqueId = 99;
  public opened = false;
  alertToDelete = 0;

  constructor(private adminService: AdminService) {}

  ngOnInit() {
    this.setUserList();
    this.setAllAlertsList();
  }

  setAllAlertsList() {
    this.alerts = [];
    this.originalAlerts = [];
    this.adminService
      .getAllAlerts(
        parseInt(this.filter.createdBy, 10),
        this.filter.whichAre.toString() === '1',
        this.alertsUniqueId
      )
      .subscribe((result) => {
        // console.log(result);
        if (result) {
          this.alerts = this.alerts.concat(result);
          this.originalAlerts = this.alerts;
          this.setAlertsDateFormat();
          this.filterAlerts();
        }
      });
  }

  setUserList() {
    this.adminService.getResponseMasterUsers().subscribe((result) => {
      if (result) {
        this.usersList = result;
      }
    });
  }

  setAlertsDateFormat() {
    this.alerts.forEach((alert) => {
      alert.createdOn = moment(alert.createdOn).format(this.constants.dateFormat);
      alert.endDate = moment(alert.endDate).format(this.constants.dateFormat);
    });
    this.originalAlerts = this.alerts;
  }

  sortAlerts(sortName) {
    this.alertsFilter = sortName;

    if (sortName === 'id') {
      this.sortById();
    } else if (sortName === 'type') {
      this.sortByType();
    } else if (sortName === 'date') {
      this.sortByDate();
    } else if (sortName === 'name') {
      this.sortByName();
    } else if (sortName === 'instructions') {
      this.sortByInstructions();
    } else if (sortName === 'displayed') {
      this.sortByDisplayed();
    } else if (sortName === 'applied') {
      this.sortByApplied();
    }
  }

  sortById() {
    this.alerts = this.alerts.sort((a, b) => a.id - b.id);
    if (!this.filterOrder.isIdAsc) {
      this.alerts.reverse();
    }
    this.filterOrder.isIdAsc = !this.filterOrder.isIdAsc;
  }

  sortByType() {
    this.alerts = this.alerts.sort((a, b) => {
      if (a.type < b.type) {
        return -1;
      }
      if (a.type > b.type) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isTypeAsc) {
      this.alerts.reverse();
    }
    this.filterOrder.isTypeAsc = !this.filterOrder.isTypeAsc;
  }

  sortByDate() {
    this.alerts = this.alerts.sort((a, b) => {
      const aDate = moment(a.createdOn, this.constants.dateFormat).format(this.sortDateFormat);
      const bDate = moment(b.createdOn, this.constants.dateFormat).format(this.sortDateFormat);
      if (aDate < bDate) {
        return -1;
      }
      if (aDate > bDate) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isDateAsc) {
      this.alerts.reverse();
    }
    this.filterOrder.isDateAsc = !this.filterOrder.isDateAsc;
  }

  sortByName() {
    this.alerts = this.alerts.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isNameAsc) {
      this.alerts.reverse();
    }
    this.filterOrder.isNameAsc = !this.filterOrder.isNameAsc;
  }

  sortByInstructions() {
    this.alerts = this.alerts.sort((a, b) => {
      if (a.instructions < b.instructions) {
        return -1;
      }
      if (a.instructions > b.instructions) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isNameAsc) {
      this.alerts.reverse();
    }
    this.filterOrder.isNameAsc = !this.filterOrder.isNameAsc;
  }

  sortByDisplayed() {
    this.alerts = this.alerts.sort((a, b) => a.timesDisplayed - b.timesDisplayed);
    if (!this.filterOrder.isDisplayedAsc) {
      this.alerts.reverse();
    }
    this.filterOrder.isDisplayedAsc = !this.filterOrder.isDisplayedAsc;
  }

  sortByApplied() {
    this.alerts = this.alerts.sort((a, b) => a.timesAccepted - b.timesAccepted);
    if (!this.filterOrder.isAppliedAsc) {
      this.alerts.reverse();
    }
    this.filterOrder.isAppliedAsc = !this.filterOrder.isAppliedAsc;
  }

  deleteAlert(alertId) {
    const alertsIds = [];
    this.alerts.forEach((alert) => {
      alertsIds.push(alert.id);
    });
    this.adminService.deleteAlert(alertId).subscribe((result) => {
      const index = alertsIds.indexOf(alertId);
      if (index > -1) {
        this.alerts.splice(index, 1);
      }
    });
  }

  filterAlerts() {
    this.alerts = this.originalAlerts;

    this.filterByShow();
    // this.filterByCreatedBy();
    // this.filterByWhichAre();
    this.filterBySearchCriteria();

    this.alertsFilter = '';
  }

  filterByShow() {
    if (this.filter.show.toString() === '99') {
      return;
    }

    // Filter alerts based on action
    this.alerts = this.alerts.filter((alert) => Number(alert.action) === Number(this.filter.show));
  }

  filterByCreatedBy() {
    this.setAllAlertsList();
  }

  filterByWhichAre() {
    this.setAllAlertsList();
  }

  filterBySearchCriteria() {
    this.alerts = this.alerts.filter((alert) => {
      let bool = false;
      if (this.searchCriteria === '') {
        bool = true;
      } else {
        if (
          alert.name.toLowerCase().indexOf(this.searchCriteria.toLowerCase()) > -1 ||
          ('000' + alert.id).toString().slice(-3).indexOf(this.searchCriteria.toLowerCase()) > -1 ||
          alert.instructions.toLowerCase().indexOf(this.searchCriteria.toLowerCase()) > -1
        ) {
          bool = true;
        }
      }
      return bool;
    });
  }

  public close() {
    this.opened = false;
  }

  public open(alertId) {
    this.alertToDelete = alertId;
    this.opened = true;
  }

  confirmDelete() {
    this.deleteAlert(this.alertToDelete);
    this.close();
  }
}
